<template>
  <span>
    <v-autocomplete
      v-model="attendeesToAdd"
      :items="attendeeOptions"
      chips
      small-chips
      label="Quick Add Attendees"
      multiple
    >
      <template v-slot:selection="data">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="remove(data.item)"
        >
          {{ data.item.text }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title v-html="data.item.text">
          </v-list-item-title>
          <v-list-item-subtitle v-html="data.item.department">
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <v-spacer></v-spacer>
    <v-btn 
      v-if="attendeesToAdd.length > 0"
      :loading="saveLoading"
      :disabled="saveLoading"
      rounded
      @click="save"
    >Add Attendees</v-btn>
  </span>
</template>

<script>
  export default {
    name: 'AddAttendee',
    props: {
      session: Object,
      employees: Array
    },
    data () {
      return {
        attendeesToAdd: [],
        saveLoading: false
      }
    },
    computed: {
      attendeeOptions () {
        return this.employees.filter(e => {
          if (this.session.fields['Attendees']) {
            return !this.session.fields['Attendees'].includes(e.id) &&
                   e.fields.Status === 'Active'
          } else {
            return true
          }
        }).map(e => {
          return {
            text: e.fields.Name,
            department: e.fields.Department,
            value: e.id
          }
        }).sort((a,b) => {
          return a.text > b.text ? 1 : -1
        })
      },
      attendeesSelection () {
        if (this.session.fields['Attendees']) {
          return this.session.fields['Attendees'].concat(this.attendeesToAdd)
        } else {
          return this.attendeesToAdd
        }
      }
    },
    methods: {
      save () {
        this.saveLoading = true
        this.$store.dispatch('updateRecords', {
          table: 'Sessions',
          records: [{
            id: this.session.id,
            fields: {
              'Attendees': this.attendeesSelection
            }
          }]
        })
        .then(() => {
          this.saveLoading = false
          this.attendeesToAdd = []
          this.$store.dispatch('getRecords', {
            table: 'Sessions',
            view: 'All Sessions',
            dispatch: 'setSessions'
          })
          this.$store.dispatch('getRecords', {
            table: 'Employees',
            view: 'All Employees',
            dispatch: 'setEmployees'
          })
        })
      },
      remove (item) {
        const index = this.attendeesToAdd.indexOf(item.value)
        if (index >= 0) this.attendeesToAdd.splice(index, 1)
      }
    }
  }
</script>
